const WorkScheduleTemplate = () => import('./components/Templates/WorkScheduleTemplate.vue');

export default [
    {
        path: '',
        component: WorkScheduleTemplate,
        name: 'admin-work-schedule-template',
    },
]
